// components/SubSectionManager.js
import React from 'react';
import { Button, InputField, Chip } from '@dhis2/ui';

const SubSectionManager = ({ 
  section, 
  onAddSubSection, 
  onRemoveSubSection, 
  onUpdateSubSectionInput 
}) => {
  return (
    <div style={{ marginLeft: '10px' }}>
      <div style={{ display: 'flex', gap: '8px', marginBottom: '10px', alignItems: 'flex-end' }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '500', marginBottom: '4px', fontSize: '14px' }}>Add Sub-section to {section.name}</div>
          <InputField
            value={section.newSubSection || ''}
            onChange={({ value }) => onUpdateSubSectionInput(value)}
            placeholder="Sub-section name"
            fullWidth
          />
        </div>
        <Button small onClick={onAddSubSection} disabled={!section.newSubSection?.trim()}>
          Add Sub-section
        </Button>
      </div>

      {section.subSections?.length > 0 && (
        <div>
          <div style={{ fontWeight: '500', marginBottom: '4px', fontSize: '14px' }}>Sub-sections:</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {section.subSections.map(subSection => (
              <Chip
                key={subSection.id}
                onRemove={() => onRemoveSubSection(subSection.id)}
              >
                {subSection.name}
              </Chip>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SubSectionManager;